class CollectionHeaderCarousel extends HTMLElement {
  constructor() {
    super()
    this.slides = this.querySelectorAll('.splide__slide')
  }

  connectedCallback() {
    this.slider = this.querySelector('.splide.collection-header-carousel')
    if (this.slides.length >= 2) {
      new Splide(this.slider, {
        interval: 5000,
        arrows: true,
        autoWidth: true,
        gap: 2,
        padding: { left: 40 },
        focus: 0,
        omitEnd: true,
        pagination: false,
        breakpoints: {
          1023: {
            padding: { left: 16 },
          },
        },
      }).mount()
    }
  }
}

if (!customElements.get('collection-header-carousel')) {
  customElements.define('collection-header-carousel', CollectionHeaderCarousel)
}
